import { render, staticRenderFns } from "./SanctionsCreate.vue?vue&type=template&id=9c2fe82c&scoped=true"
import script from "./SanctionsCreate.vue?vue&type=script&lang=js"
export * from "./SanctionsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2fe82c",
  null
  
)

export default component.exports